import { render, staticRenderFns } from "./ConfigurationProcess.vue?vue&type=template&id=0f6485a4"
import script from "./ConfigurationProcess.vue?vue&type=script&lang=js"
export * from "./ConfigurationProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports